import { SText } from '@setvi/shared/components';
import { Product } from '@setvi/shared/interfaces';

interface FamilyProps {
  product: Product;
}

export const Family = ({ product }: FamilyProps) => (
  <SText
    title={
      // @ts-ignore
      product?.custom?.family || '-'
    }
  />
);
